import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-coordinate"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.2725 4.22217L18.8857 8.11106V15.8888L12.2725 19.7777L5.65918 15.8888V8.11106L12.2725 4.22217Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.2724 4.22222L18.8857 8.11111V15.8889M12.2724 4.22222L5.65909 8.11111V15.8889M12.2724 4.22222V2M18.8857 15.8889L12.2724 19.7778M18.8857 15.8889L21 17M12.2724 19.7778L5.65909 15.8889M12.2724 19.7778V22M12.2724 19.7778L12.2727 12M5.65909 15.8889L3 17M12.2727 12L18.4723 8.35419M12.2727 12L6.07244 8.35419","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemCoordinate = Vue.extend<IconProps>({
  name: 'SystemCoordinateIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-coordinate',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SystemCoordinate;
